import actionFe from 'utils/mw/actionFe.util';

const feBookingCleanUpNewClient = actionFe('feBookingCleanUpNewClient');

// noinspection JSUnusedGlobalSymbols
export default feBookingCleanUpNewClient;
